import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PrescriptionSourceTypeEnum } from 'src/app/enums/prescription-source-type.enum';
import { AllAppointmentsData } from 'src/app/_models/all-appointments.model';
import { PatientService } from 'src/app/_services/patient.service';
import { PatientDetailsComponent } from '../patient-details/patient-details.component';

@Component({
  selector: 'app-successfull-request-modal',
  templateUrl: './successfull-request-modal.component.html',
  styleUrls: ['./successfull-request-modal.component.scss']
})
export class SuccessfullRequestModalComponent implements OnInit  {
  patientId;
  testRequestId;
  orderMerchantId = '';

  public event: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private router: Router,
    private patientService: PatientService
  ) { }

  ngOnInit(): void {}

  handleModalHide() {
    this.bsModalRef.hide();
    this.router.navigate(['patient-details', this.patientId]);
  }

  handleViewRequest() {
    this.bsModalRef.hide();
    this.event.emit('View Request Details');
    this.router.navigate(['test-request-details'],
     { queryParams: {medicalTestId: this.testRequestId, sourceType: PrescriptionSourceTypeEnum.details}});
  }

  handleCreateRequest() {
    this.bsModalRef.hide();
    this.event.emit('create');
    this.router.navigate(['patient-details', this.patientId, 'add-new-test']);
  }

  handleBackToRequests() {
    this.bsModalRef.hide();
    this.event.emit('Back To Daily Tasks');
    this.router.navigate(['patient-details', this.patientId]);
    this.patientService.isMedicalTests.next(true);
  }
}
